export default "__VITE_ASSET__rY2IAQpy__"